module.exports = __webpack_public_path__ + "assets/avatar-cuddles.092172b8.svg";